import DashboardContainer from "../masks/admin/dashboardContainer/DashboardContainer";
import CmsPage from "../masks/public/cmsPage/CmsPage";
import Contact from "../masks/public/contact/Contact";
import EventData from "../masks/public/eventData/EventData";
import EventList from "../masks/public/eventList/EventList";
import ForgotPassword from "../masks/public/forgotPassword/ForgotPassword";
import Login from "../masks/public/login/Login";
import AllMap from "../masks/public/map/AllMap";
import ProjectData from "../masks/public/projectData/ProjectData";
import ProjectList from "../masks/public/projectList/ProjectList";
import ResetPassword from "../masks/public/resetPassword/ResetPassword";
import RoutesEnum from "./RoutesEnum";

const Routes = [
    {
        path: "/datenverwaltung",
        name: "DashboardContainer",
        component: DashboardContainer,
    },
    {
        path: "/anmelden",
        name: "publicLogin",
        component: Login,
    },
    {
        path: "/" + RoutesEnum.PORTAL_FORGOT_PASSWORD,
        name: "forgotPassword",
        component: ForgotPassword,
    },
    {
        path: RoutesEnum.PORTAL_RESET_PASSWORD + "/:token",
        name: "resetPasswordWithId",
        component: ResetPassword,
    },
    {
        path: RoutesEnum.PORTAL_RESET_PASSWORD,
        name: "resetPassword",
        component: ResetPassword,
    },
    {
        path: RoutesEnum.PORTAL_PROJECT + "/:id",
        name: "projectData",
        component: ProjectData,
    },
    {
        path: RoutesEnum.PORTAL_PROJECT_LIST,
        name: "projectListExplicit",
        component: ProjectList,
    },
    {
        path: RoutesEnum.PORTAL_MAP,
        name: "publicMap",
        component: AllMap,
    },
    {
        path: RoutesEnum.PORTAL_EVENT + "/:id",
        name: "eventData",
        component: EventData,
    },
    {
        path: RoutesEnum.PORTAL_EVENT_LIST,
        name: "eventListExplicit",
        component: EventList,
    },
    {
        path: RoutesEnum.PORTAL_CONTACT,
        name: "kontaktForm",
        component: Contact,
    },
    {
        path: "/" + RoutesEnum.PORTAL_PAGE + "/:pageKey",
        name: "cmsPage",
        component: CmsPage,
    },
    {
        path: "/:id/seite/:pageKey",
        name: "projectDataPageByRootKey_Tab",
        component: ProjectData,
    },
    {
        path: "/:id/:tabKey",
        name: "projectDataByRootKey_Tab",
        component: ProjectData,
    },
    {
        path: "/:id",
        name: "projectDataByRootKey",
        component: ProjectData,
    },
    {
        path: "/",
        name: "projectList",
        component: ProjectList,
    },
];

export default Routes;
